module.exports = __webpack_public_path__ + "assets/images/health_r.0cf7747c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/health_r.png
// module id = 727
// module chunks = 1